export const hoverLift = {
  transition: 'transform 180ms ease, box-shadow 180ms ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: 3,
  },
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    '&:hover': {
      transform: 'none',
    },
  },
};

export const publicLink = {
  color: 'text.primary',
  fontWeight: 700,
  textDecorationColor: 'brand.yellow',
  '&:hover': {
    color: 'text.primary',
  },
};

export const focusRing = {
  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: 'brand.yellow',
    outlineOffset: 3,
  },
};

export function scrollToId(id: string) {
  const node = document.getElementById(id);
  if (!node) return;
  const reduce =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  node.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
}
